import { render } from "./massive-modification-form.vue?vue&type=template&id=07d50e9a"
import script from "./massive-modification-form.vue?vue&type=script&lang=js"
export * from "./massive-modification-form.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__